import { ICustomerInitialState } from "../../../types/master/customerInterface";
import { CustomerActionTypes, CustomerActions } from "../../actionTypes/master/customerActionTypes";


const initialState: ICustomerInitialState = {
  loading: false,
  error: null,
  customerList: [],
  customerData: {
    id: 0,
    customer_code: "",
    company_name: "",
    parent_customer_id: 0,
    is_gst_applicable: 0,
    gst_rate: 0,
    pan_card_no: "",
    mis_email: "",
    billing_email: "",
    customer_categorie: "",
    operation_email: "",
    contact_person_designation: "",
    api_access: 0,
    sac_code: "",
    credit_days: 0,
    credit_limit: 0,
    email: "",
    address: "",
    profile_status: "",
    pincode: "",
    assigned_customer_support: "",
    contact_number: "",
    contact_person: "",
    gstin: "",
    contact_person_id: 0,
    gps_location: "",
    customer_name: "",
    created_by: 0,
    createdAt: "",
    updatedAt: "",
    customer_documents: [], // Add this empty array
    user: {
      id: 0,
      name: "",
    },
    pincodes: {
      id: 0,
      pincode: "",
      district: {
        id: 0,
        district_name: "",
        state: {
          id: 0,
          state_name: "",
        },
      },
    },
  },
  customerListPageCount: 0,
  
};

export default function customerReducer(state = initialState, action: CustomerActionTypes): ICustomerInitialState {
  switch (action.type) {

    case CustomerActions.SET_CUSTOMER_LIST:
      return {
        ...state,
        customerList: action.payload    
      };

    case CustomerActions.SET_CUSTOMER_LIST_PAGE_COUNT:
      return {
        ...state,
        customerListPageCount: action.payload
      };

    case CustomerActions.SET_CUSTOMER_DATA_BY_ID:
      return {
        ...state,
        customerData: action.payload
      }

    default:
      return state;
  }
}
